exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head[data-v-d1e617ac],\n.content[data-v-d1e617ac] {\n  width: 100%;\n}\n.head[data-v-d1e617ac] {\n  padding-bottom: 10px;\n}\n.content[data-v-d1e617ac] {\n  display: flex;\n  justify-content: space-between;\n}\n.content .info span[data-v-d1e617ac] {\n    display: inline-block;\n    width: 100%;\n}\n.content .actions[data-v-d1e617ac] {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.content .actions button[data-v-d1e617ac] {\n      margin-left: 20px;\n}\n", ""]);

// exports
